function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.729,1.2l3.346,6.629l6.44,0.638l2.77084e-08,2.30255e-09c0.443062,0.0368183 0.772388,0.425838 0.735569,0.8689c-0.0158758,0.191045 -0.0994087,0.370154 -0.23557,0.5051l-5.3,5.253l1.965,7.138l7.40414e-10,2.78829e-09c0.115238,0.433968 -0.143144,0.879187 -0.577111,0.994425c-0.192128,0.0510186 -0.396291,0.0298781 -0.573889,-0.0594247l-6.529,-3.233l-6.52,3.229l2.65259e-08,-1.33382e-08c-0.401148,0.201712 -0.889863,0.040037 -1.09158,-0.361111c-0.0893028,-0.177598 -0.110443,-0.381761 -0.0594247,-0.573889l1.965,-7.138l-5.304,-5.253l-1.88758e-08,-1.87074e-08c-0.315777,-0.312961 -0.31806,-0.822653 -0.00509979,-1.13843c0.134946,-0.136161 0.314055,-0.219694 0.5051,-0.235569l6.44,-0.638l3.341,-6.625l-3.12307e-08,6.09963e-08c0.206144,-0.402616 0.69964,-0.561888 1.10226,-0.355744c0.152968,0.0783212 0.277423,0.202776 0.355744,0.355744Z",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var SvgRatingStar = function SvgRatingStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRatingStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rating-star.65d746a6.svg";
export { ForwardRef as ReactComponent };